import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import auth from '@feathersjs/authentication-client'
import io from 'socket.io-client'
import { iff, discard } from 'feathers-hooks-common'
import feathersVuex from '@feathersjs/vuex'
// import { store } from '@/store'
// import router from '@/router'

const socket = io(process.env.NODE_ENV === 'development' ? process.env.VUE_APP_API : window.location.origin, {
  transports: ['websocket'],
  timeout: 30000, // 30 seconds timeout for slow network connections
})

const feathersClient = feathers()
  .configure(socketio(socket, { timeout: 30000 })) // 30 seconds timeout for service calls
  .configure(auth({ storage: window.localStorage, storageKey: 'kompass-jwt' }))
  .hooks({
    before: {
      all: [
        iff(
          context => ['create', 'update', 'patch'].includes(context.method),
          discard('__id', '__isTemp'),
        ),
      ],
    },
    error (context) {
      const shouldSkipRedirect = typeof window !== 'undefined' && window.linkCompassSkip401Redirect
      if (context.error.code === 401 && location.pathname !== '/login' && !shouldSkipRedirect) {
        console.log('401!')
        location.href = '/login'
      }
    },
  })

export default feathersClient

// Setting up feathers-vuex
const { makeServicePlugin, makeAuthPlugin, BaseModel, models, FeathersVuex } = feathersVuex(
  feathersClient,
  {
    serverAlias: 'api', // optional for working with multiple APIs (this is the default value)
    // idField: '_id', // Must match the id field in your database table/collection
    whitelist: ['$regex', '$options'],
  },
)

export { makeAuthPlugin, makeServicePlugin, BaseModel, models, FeathersVuex }
